export default function CategoryBanner() {
  const categories = [
    {
      image: "https://images.puma.net/images/fn/%7Eregional%7ETUR%7Eothers%7EKOP%7EAW25%7EOctober+Home+Page%7Ehotpursuitpack.jpg",
      title: "TURN UP THE HEAT",
      subtitle: "IN FUTURE, ULTRA & KING"
    },
    {
      image: "https://images.puma.net/images/fn/%7Eregional%7ETUR%7Eothers%7EKOP%7EAW25%7ENovember+Home+Page%7E25AW_Ecom_TS_Football_FPF_Eusebio_Matchwear_Product_Homepage.jpg",
      title: "EFSANEYE KULAK VER",
      subtitle: "PANTERA NEGRA SPECIAL EDITION"
    },
    {
      image: "https://images.puma.net/images/fn/%7Eregional%7ETUR%7Eothers%7EKOP%7EAW25%7EOctober+Home+Page%7Egsk_xray.jpg",
      title: "GALATASARAY X-RAY SNEAKER",
      subtitle: "SAHALARDAN SOKAKLARA"
    }
  ];

  return (
    <section className="py-8 md:py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {categories.map((category, index) => (
            <div key={index} className="group cursor-pointer">
              <div className="relative overflow-hidden mb-4">
                <img 
                  src={category.image}
                  alt={category.title}
                  className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="text-center">
                <h3 className="text-lg font-bold mb-2">{category.title}</h3>
                <p className="text-sm text-gray-600 mb-4">{category.subtitle}</p>
                <button className="bg-black text-white px-6 py-2 text-sm font-bold hover:bg-gray-800 transition whitespace-nowrap cursor-pointer">
                  ALIŞVERİŞE BAŞLA
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
